<template>
  <div>
    <v-navigation-drawer
      height="100%"
      permanent
      :color="$vuetify.theme.primary || '#39424E'"
      dark
      class="drawer hidden-sm-and-down"
      width="327"
    >
      <div
        style="height: 100%; max-height: 950px"
        class="d-flex flex-column justify-space-around align-center"
      >
        <div class="pl-8 pr-4" style="width: 100%">
          <v-timeline dense>
            <v-timeline-item>
              <template v-slot:icon>
                <v-avatar
                  :color="step > 0 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 0
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step > 0 ? 'white' : '#39424E'"
                    >mdi-account-outline</v-icon
                  >
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">1</strong>
                <div>
                  <span class="step-info">Informações pessoais</span>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item>
              <template v-slot:icon>
                <v-avatar
                  :color="step > 1 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 1
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step > 1 ? 'white' : '#39424E'"
                    >mdi-card-text-outline</v-icon
                  >
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">2</strong>
                <div>
                  <span class="step-info">Resultados</span>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item>
              <template v-slot:icon>
                <v-avatar
                  :color="step > 2 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 2
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step > 2 ? 'white' : '#39424E'">
                    mdi-piggy-bank
                  </v-icon>
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">3</strong>
                <div>
                  <span class="step-info">Simulação final</span>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item>
              <template v-slot:icon>
                <v-avatar
                  :color="step > 3 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 3
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step > 3 ? 'white' : '#39424E'">
                    mdi-form-select
                  </v-icon>
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">4</strong>
                <div>
                  <span class="step-info">Proposta</span>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item>
              <template v-slot:icon>
                <v-avatar
                  :color="step > 4 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 4
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step > 4 ? 'white' : '#39424E'">
                    mdi-cart-check
                  </v-icon>
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">5</strong>
                <div>
                  <span class="step-info">DPS</span>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item>
              <template v-slot:icon>
                <v-avatar
                  :color="step > 5 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 5
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step == 5 ? 'white' : '#39424E'">
                    mdi-check
                  </v-icon>
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">6</strong>
                <div>
                  <span class="step-info">Finalização</span>
                </div>
              </div>
            </v-timeline-item>
          </v-timeline>
        </div>

        <div
          v-if="socio"
          class="d-flex flex-column justify-space-around align-center mb-8"
        >
          <v-img class="mb-3" :src="socio.logo" contain width="200"></v-img>
        </div>
        <div
          v-else
          class="d-flex flex-column justify-space-around align-center mb-8"
        >
          <v-img
            class="mb-3"
            src="../../../../assets/logo.svg"
            contain
            max-width="60"
          ></v-img>
          <v-img
            src="../../../../assets/name.svg"
            contain
            max-width="150"
          ></v-img>
        </div>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
      height=""
      permanent
      :color="$vuetify.theme.primary || '#39424E'"
      dark
      class="pa-4 mobile-drawer hidden-md-and-up"
      bottom
      width="100%"
      touchless
    >
      <div class="d-flex justify-center align-center">
        <div class="d-flex align-center mobile-row">
          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
              :color="step > 0 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 0
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step > 0 ? 'white' : '#39424E'"
                >mdi-account-outline</v-icon
              >
            </v-avatar>

            <br />

            <span class="step-info"
              >Informações <br />
              pessoais</span
            >
          </div>

          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
              :color="step > 1 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 1
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step > 1 ? 'white' : '#39424E'"
                >mdi-card-text-outline</v-icon
              >
            </v-avatar>

            <br />

            <span class="step-info">Resultados </span>
            <br />
          </div>

          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
              :color="step > 2 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 2
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step > 2 ? 'white' : '#39424E'">
                mdi-piggy-bank
              </v-icon>
            </v-avatar>

            <br />

            <span class="step-info">
              Simulação <br />
              final
            </span>
          </div>

          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
              :color="step > 3 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 3
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step > 3 ? 'white' : '#39424E'">
                mdi-form-select
              </v-icon>
            </v-avatar>

            <br />

            <span class="step-info"> Proposta </span>
          </div>

          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
              :color="step > 4 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 4
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step > 4 ? 'white' : '#39424E'">
                mdi-cart-check
              </v-icon>
            </v-avatar>

            <br />

            <span class="step-info"> DPS </span>
          </div>

          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
              :color="step > 5 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 5
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step == 5 ? 'white' : '#39424E'">
                mdi-check
              </v-icon>
            </v-avatar>

            <br />

            <span class="step-info"> Finalização </span>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<style scoped>
.drawer {
  border-radius: 25px 0px 0px 25px !important;
}

.mobile-drawer {
  display: flex;
  justify-content: space-around;
  border-radius: 0px 0px 25px 25px !important;
  width: 100%;
}

.mobile-row {
  max-width: 600px;
  padding-bottom: 10px;
  overflow-x: auto;
}

.mobile-row::-webkit-scrollbar {
  background-color: #ccc;
  width: 8px;
  height: 8px;
}

.mobile-row::-webkit-scrollbar-thumb {
  background-color: #f5f5f5;
  border-radius: 20px;
}

.mobile-col {
  min-width: 100px;
}

.v-timeline:before {
  width: 3px;
  background-color: #fff !important;
}

.step {
  font-weight: bold;
  font-size: 35px;
  line-height: 62px;
  text-align: right;
  letter-spacing: 0.15px;
  color: var(--custom-white-second-color);
}

.step-info {
  font-weight: normal;
  font-size: 15px;
  line-height: 16px;
  letter-spacing: 0.15px;
  color: var(--custom-white-second-color);
}

@media (max-width: 800px) {
  .step-info {
    font-size: 12px;
    line-height: unset;
  }

  .mobile-row {
    max-width: 320px;
    padding-bottom: 10px;
    overflow-x: auto;
  }
}
</style>

<script>
export default {
  props: {
    step: Number,
    socio: Object,
  },
  name: "Drawer",
};
</script>
